// src/components/forms/CustomCheckbox.jsx
import { IoCheckmark } from "react-icons/io5";

const CustomCheckbox = ({
  checked,
  onChange,
  label,
  id,
  name,
  disabled = false,
  className = "",
  size = "medium",
  color,
}) => {
  const sizeMap = {
    small: "h-4 w-4",
    medium: "h-5 w-5",
    large: "h-6 w-6",
  };

  const iconSizeMap = {
    small: "text-xs",
    medium: "text-sm",
    large: "text-base",
  };

  const boxSize = sizeMap[size] || sizeMap.medium;
  const iconSize = iconSizeMap[size] || iconSizeMap.medium;

  const checkedStyle = color && checked ? { backgroundColor: color, borderColor: color } : {};

  return (
    <label
      className={[
        "inline-flex items-center gap-2 select-none",
        disabled ? "cursor-not-allowed opacity-60" : "cursor-pointer",
        className,
      ].join(" ")}
    >
      {/* Native checkbox (hidden, but still controls toggle reliably) */}
      <input
        type="checkbox"
        id={id}
        name={name}
        checked={checked}
        disabled={disabled}
        onChange={() => {
          if (!disabled) onChange(); // ✅ preserves your existing parent onChange signature
        }}
        className="sr-only"
      />

      {/* Custom UI box */}
      <span
        className={[
          "flex items-center justify-center rounded border transition",
          boxSize,
          checked
            ? "bg-teal-600 border-teal-600"
            : "bg-white border-slate-300 dark:bg-slate-950 dark:border-slate-700",
        ].join(" ")}
        style={checked ? checkedStyle : undefined}
        aria-hidden="true"
      >
        {checked ? <IoCheckmark className={`text-white ${iconSize}`} /> : null}
      </span>

      {/* Label text */}
      {label ? (
        <span className="text-sm text-slate-800 dark:text-slate-100">
          {label}
        </span>
      ) : null}
    </label>
  );
};

export default CustomCheckbox;
